/**
 * Frontend configuration
 * Uses environment variables with fallbacks
 */

export const config = {
  // Frontend URL (for SEO metadata, OG images, canonical URLs)
  frontendUrl: process.env.NEXT_PUBLIC_FRONTEND_URL || 'http://localhost:3000',

  // Backend API URL
  apiUrl: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000',

  // Site name
  siteName: 'Transcriptr',

  // Environment detection
  isProduction: process.env.NEXT_PUBLIC_FRONTEND_URL === 'https://transcriptr.ai',
}
